export const wcTokenCookieName = 'WC_USERACTIVITY_';
export const wcTrustedTokenCookieName = 'WC_AUTHENTICATION_';
export const msIdentityCookieName = 'MS_API_IDENTITY';
export const msUserCookieName = 'MS_USER_COOKIE_';
export const completeProfileDataCookieName = 'MS_ACCOUNT_CP_DATA';
export const singleSignOnCookieName = 'ce-sso-session';
export const platformIdentifierCookieName = 'platform';
export const platformCookieValueWebView = 'mobileapp';
export const loyaltyTokenCookieName = 'MS_ONYX_LOYALTY_TOKEN';
export const sparksDataCookieName = 'MS_ONYX_SPARKS_DATA';
export const basketSizeCookieName = 'basketSize_';
export const savedItemSizeCookieName = 'savedItemSize_';
export const slotDetailsCookieName = 'MS_CFTO_SLOT_DETAILS';
export const cftoTerritoryCookieName = 'MS_CFTO_TERRITORY';
export const taggstarVisitorIdCookieName = 'MS_TAGGSTAR_VID';
export const trueFitUserTokenCookieName = 'MS_TRUEFIT_TOKEN';
export const loyaltyCookieUkName = 'IS_LOYALTY_USER_COOKIE';
export const loyaltyCookieRoiName = 'IS_LOYALTY_USER_COOKIE_IE';
export const insuranceCookieNameForPet = 'IS_FLYOUT_SEEN_PET';
export const insuranceCookieNameForTravel = 'IS_FLYOUT_SEEN_TRAVEL';
export const insuranceCookieNameForHome = 'IS_FLYOUT_SEEN_HOME';
export const sapStoreIdCookieName = 'SAP_STORE_ID';
export const subChannelCookieName = 'MS_SUB_CHANNEL';

// NOTE - this cookie name is also used by the native app food catalogue; don't change the name without letting the team know
export const foodCatalogueSelectedStoreCookieName = 'MS_FOOD_STORE';
export const msSessionId = 'MS-SESSION-ID';
export const experienceCloudIdCookieName = 's_ecid';
export const experimentsUserIdCookieName = 'experimentsUserId';
export const onyxAuthCookieName = 'ONYX_AUTH';

export const serverSideOnlyCookies = {
  wcPersistentCookieName: 'WC_PERSISTENT',
  resetPasswordTokenCookieName: 'MS_RESET_PASSWORD_TOKEN',
} as const;
